// this file is duplicated from: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/e5266dfa1be0a5514fd143fbdf92355c1fc10f4b/static/js/routing-rules/records/RoutingRuleBase.ts
import { Iterable as ImmutableIterable, Record as ImmutableRecord, fromJS } from 'immutable';
import { DISTRIBUTIONS } from '../constants/distributions';
const checkIsRoutingRule = options => ImmutableIterable.isIterable(options) && ImmutableIterable.isKeyed(options);
const ensureOptionalPropsPopulated = options => options.update('shouldFilterToAvailable', shouldFilterToAvailable => typeof shouldFilterToAvailable === 'boolean' ? shouldFilterToAvailable : true).update('rotationMethod', rotationMethod => rotationMethod === DISTRIBUTIONS.LEAST_BUSY ? rotationMethod : DISTRIBUTIONS.RANDOM);

// Taking this approach from: https://github.com/facebook/immutable-js/issues/334#issuecomment-226097016
const RoutingRuleBase = (defaultValues, name) => {
  const realDefaults = Object.assign({}, defaultValues, {
    rotationMethod: DISTRIBUTIONS.RANDOM,
    shouldFilterToAvailable: true
  });
  return class RoutingRuleBaseFactory extends ImmutableRecord(realDefaults, name) {
    constructor(options) {
      let finalOptions;
      if (checkIsRoutingRule(options)) {
        finalOptions = ensureOptionalPropsPopulated(options);
      } else if (options) {
        finalOptions = ensureOptionalPropsPopulated(fromJS(options));
      }
      super(finalOptions);
    }
  };
};
export default RoutingRuleBase;